import React from "react";

export function ProgressWave({ pct = 0, height = "h-4", showMilestones = false }) {
  const clamped = Math.max(0, Math.min(100, pct));
  return (
    <div className="relative w-full" data-testid="progress-wave">
      <div className={`wave-meter ${height} w-full`}>
        <div className="wave-fill" style={{ width: `${clamped}%` }} />
      </div>
      {showMilestones && (
        <div className="pointer-events-none absolute inset-0">
          {[25, 50, 75].map((m) => (
            <div
              key={m}
              className="absolute top-0 bottom-0 w-px bg-white/70"
              style={{ left: `${m}%` }}
            />
          ))}
        </div>
      )}
    </div>
  );
}
